module.exports = __webpack_public_path__ + "static/media/uploadSvg.2f3bf277.svg";